// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__8Kg8W","left":"StickyBox_left__jHRlT","right":"StickyBox_right__3Qn60"};